import Component from 'flarum/common/Component';
import AnnouncementListItem from "./AnnouncementListItem";
import Select from 'flarum/common/components/Select';
import Stream from 'flarum/utils/Stream';

import addDaysToDate from '../common/util/addDaysToDate';
import showAlert from '../common/util/showAlert';
import getUserInfo from "../common/util/getUserInfo";

import Fuse from 'fuse.js'

export default class MapSearchComponent extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.filterSearchType = Stream("0");
    this.mapModule = this.attrs.mapModule;
    this.mapInfoDataList = this.attrs.mapInfoDataList;
    this.searchKeyword = "";

    this.fuse = new Fuse(this.mapInfoDataList, {
      useExtendedSearch: true,
      keys: ["city","sn","type","status","assignedAt"]
    });
  }

  oncreate(vnode) {
    super.oncreate(vnode);
  }

  searchOptions(){
    return (
      <Select
        value={this.filterSearchType()}
        style="width:116px;"
        className="u2diMapSearchFilterList" 
        disabled={this.loading}
        options={{
          '0': app.translator.trans('ziven-u2di.forum.filter-search-all'),
          '1': app.translator.trans('ziven-u2di.forum.filter-search-selling'),
          '2': app.translator.trans('ziven-u2di.forum.filter-search-three-month'),
          '3': app.translator.trans('ziven-u2di.forum.filter-search-one-year'),

          'zzyd': app.translator.trans('ziven-u2di.forum.filter-search-zzyd'),
          'syyd': app.translator.trans('ziven-u2di.forum.filter-search-syyd'),
          'gyyd': app.translator.trans('ziven-u2di.forum.filter-search-gyyd'),
          'wlcc': app.translator.trans('ziven-u2di.forum.filter-search-wlcc'),

          'syjz': app.translator.trans('ziven-u2di.forum.filter-search-syjz'),
          'gyjz': app.translator.trans('ziven-u2di.forum.filter-search-gyjz'),
          'wlck': app.translator.trans('ziven-u2di.forum.filter-search-wlck'),
          'nzjd': app.translator.trans('ziven-u2di.forum.filter-search-nzjd'),
        }}
        buttonClassName="Button"
        onchange={(e) => {
          this.filterSearchType(e);
          this.searchInput(e,true)
        }}
      />
    );
  }

  view() {
    return (
      <div>
        <div className="u2diMapSideBarSearchContainer">
          <div>{this.searchOptions()}</div>
          <div className="Search-input u2diSearchInputContainer">
            <input oninput={(e) => { this.searchKeyword = e.target.value; }} onkeypress={(e) => {this.searchInput(e)}} className="FormControl u2diSearchInput" type="search" placeholder={app.translator.trans('ziven-u2di.forum.map-sidebar-search-placeholder')} />
          </div>
        </div>

        <div className="u2diMapSideBarMobileSearchContainer">
          <div>{this.searchOptions()}</div>
          <div className="Search-input u2diSearchInputContainer">
            <input oninput={(e) => { this.searchKeyword = e.target.value; }} onkeypress={(e) => {this.searchInput(e)}} className="FormControl u2diSearchInput" type="search" placeholder={app.translator.trans('ziven-u2di.forum.map-sidebar-search-placeholder')} />
          </div>
        </div>
      </div>
    );
  }

  dateRange(startDate, endDate) {
    var start      = startDate.split('-');
    var end        = endDate.split('-');
    var startYear  = parseInt(start[0]);
    var endYear    = parseInt(end[0]);
    var dates      = [];

    for(var i = startYear; i <= endYear; i++) {
      var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
      var startMon = i === startYear ? parseInt(start[1])-1 : 0;
      for(var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j+1) {
        var month = j+1;
        var displayMonth = month < 10 ? '0'+month : month;
        dates.push([i, displayMonth, '01'].join('-'));
      }
    }
    return dates;
  }

  searchInput(e,forceSearch){
    if(e.key!=="Enter" && forceSearch===false){
      return;
    }

    const keyword = (this.searchKeyword).trim();
    const filterSearchType = this.filterSearchType();

    let queryCondition = {};

    if(["zzyd","syyd","gyyd","wlcc","syjz","gyjz","wlck","nzjd"].indexOf(filterSearchType)!==-1){
      queryCondition.type = "="+filterSearchType;
    }else{
      if(filterSearchType==0){
        queryCondition.status = "=0 | =1 | =2 | =3";
      }else if(filterSearchType==1){
        queryCondition.status = "=0";
      }else if(filterSearchType==2 || filterSearchType==3){
        const days = filterSearchType==2?90:365;
        const currentDate = new Date().toJSON().slice(0,10);
        const endDate = dayjs(addDaysToDate(currentDate,days)).format('YYYY-M-D');
        const monthsBetween = this.dateRange(currentDate,endDate);

        queryCondition.assignedAt = "";

        for(let i=0;i<monthsBetween.length;i++){
          let month = monthsBetween[i].slice(0,7);
          let data = i===0?"^"+month:" | ^"+month;
          queryCondition.assignedAt+=data;
        }
      }
    }

    const searchQuery = {
      $and: []
    };

    if(keyword!==""){
      searchQuery.$and.push(
        {
          $or: [
            // { city: "="+keyword+" | '"+keyword },
            { sn: "="+keyword+" | '"+keyword },
          ]
        }
      );
    }

    if(Object.keys(queryCondition).length>0){
      searchQuery.$and.unshift(queryCondition);
    }

    const u2diUserType9 = app.forum.attribute('u2diUserType9');
    let searchResult = this.fuse.search(searchQuery);
    let cluster = [];

    for(let index in searchResult){
      const itemData = searchResult[index].item;
      const itemID = itemData.id;
      const itemSN = itemData.sn;
      const userID = itemData.user_id;
      const itemLat = itemData.lat;
      const itemLng = itemData.lng;
      const itemPrice = itemData.price;
      const itemType = itemData.type;
      const itemCategory = itemData.category;
      const itemStatus = itemData.status;
      const itemFlag = itemData.flag;
      let itemLatModifier = 0;
      let itemLngModifier = 0;

      if(itemFlag!==1){
        if((app.session.user && userID==app.session.user.id()) || u2diUserType9===true){
          let userInfo = getUserInfo(app.session.user.id())
          let assignedAt = userInfo.assignedAt();
          let key = (itemSN%5)*2+1;
          
          itemLatModifier=(assignedAt[key]/10/100);
          itemLngModifier=(assignedAt[key+1]/10/100);
        }
      }

      cluster.push({
        lnglat:[itemLng+itemLngModifier,itemLat+itemLatModifier],
        itemID:itemID,
        userID:userID,
        price:itemPrice,
        type:itemType,
        category:itemCategory,
        status:itemStatus,
        dataType:"info"
      });
    }

    this.mapModule.emit('clearInfoWindow');

    this.mapModule.emit('mapAddCluster',{
        cluster : cluster,
    });

    this.mapModule.emit('mapZoomOut',{
        position :[108.925649,37.31221],
        zoom: 4.5
    });

    if(cluster.length===0){
      showAlert(app.translator.trans('ziven-u2di.forum.error-search-empty'));
    }else{
      console.log(cluster[0]);
      setTimeout(function(){
        $(window).trigger('u2diLocateInfoOnMap', {
          position : cluster[0].lnglat,
          itemID: cluster[0].itemID,
          targetID: cluster[0].itemID,
          dataType: "info"
        });
      },750);
    }
  }

}